import {container, primaryColor, secondaryColor, sidebarColor} from "../../../nextjs-material-kit.js";
import { cardTitle, title } from "../../../nextjs-material-kit.js";
import imagesStyles from "../../imagesStyles.js";
import {regularCta} from "../../button";
import {insetLogoSize, insetLogoSizeInt} from "../../const";

const logoPadding = '20px';

const jobOverviewStyle = (theme) => ({
  cta: {
    ...regularCta,
    marginRight: "13px",
    "@media (max-width: map-get($grid-breakpoints, 'lg'))": {
      marginRight: 0,
    },
  },
  employerLogoOuterContainer: {
    position: "absolute",
    zIndex: "1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    bottom: "-15px",
    left: "25px",
    height: `calc(${insetLogoSize} + 20px)`,
    width: `calc(${insetLogoSize} + 20px)`,
  },
  employerLogoInnerContainer: {
    padding: "20px",
    border: "1px solid #27B0AE",
    backgroundColor: "#eaf6fe",
  },
  employerLogo: {
    // `backgroundImage` to be set dynamically inline.
    minHeight: `calc(${insetLogoSize} - ${logoPadding})`,
    backgroundPosition: "center",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
  },
  paddingZero: {
    "@media (max-width: map-get($grid-breakpoints, 'lg'))": {
      padding: "0 !important",
    },
  },
  applyBtnGrid: {
    display: "flex",
    alignItems: "center",
    float: "right !important",
    marginRight: "30px",
    "@media (max-width: 992px)": {
      justifyContent: "space-around",
      marginTop: "0",
      marginRight: "0",
      marginLeft: "10px !important",
      float: 'inherit !important',
    },
  },
  icons: {
    cursor: "pointer",
    margin: 0,
    marginRight: "13px",
    "@media (max-width: map-get($grid-breakpoints, 'lg'))": {
      margin: "0 !important",
      width: "fit-content",
    },
  },
  applyBtn: {
    margin: 0,
    marginRight: "13px",
    padding: "5px 28px !important",
    fontWeight: "400",
    fontSize: "16px !important",
    "@media (max-width: map-get($grid-breakpoints, 'lg'))": {
      marginRight: 0,
    },
  },
  title: {
    ...title,
    marginBottom: "1rem",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none",
  },
  floatLeft: {
    float: "left",
    paddingLeft: "0",
  },
  floatRight: {
    float: "right",
  },
  jobPic: {
    border: "1px solid " + secondaryColor,
    maxWidth: "268px !important",
    marginLeft: "40px !important",
    marginTop: "70px",
    marginBottom: "-20px",
    height: "120px !important",
  },
  jobStat: {
    marginLeft: "0",
    marginRight: "0",
    padding: "0",
    display: "flex", // Helps icons line up w/ stats vertically.
    alignItems: "center",
  },
  primaryColor: {
    backgroundColor: "#095a70",
  },
  lightBlue: {
    backgroundColor: "#7db2e1",
  },
  jobTab: {
    paddingBottom: "15px",
    paddingTop: "50px",
    "@media (max-width: map-get($grid-breakpoints, 'lg'))": {
      paddingRight: 0,
    },
  },
  ...imagesStyles,
  itemGrid: {
    // This ensures the card details have enough space after the employer logo, including on
    // mobile sizes when the full-width banner is much less tall.
    minHeight: "150px",
    marginLeft: "auto",
    marginRight: "auto",
    borderRadius: "0",
    padding: "0px",
    border: "0",
    borderBottom: "none",
  },
  generalTitle: {
    color: primaryColor,
    fontFamily: "var(--font-brandon-grotesque)",
    fontWeight: 900,
    marginBottom: "1.6rem",
  },
  cardTitle: {
    ...cardTitle,
    paddingLeft: "25px",
    fontFamily: "var(--font-brandon-grotesque)",
    fontWeight: 900,
    color: sidebarColor + " !important",
    fontSize: "20px",
    letterSpacing: "0px",
    lineHeight: 1.2,
    wordSpacing: "0px",
  },
  cardSubTitle: {
    fontFamily: "var(--font-brandon-grotesque)",
    fontWeight: 900,
    textAlign: "left",
    color: primaryColor,
    fontSize: "24px",
    marginTop: "1rem",
  },
  smallTitle: {
    color: "#1a1a1a",
    fontFamily: "var(--font-brandon-grotesque)",
  },
  description: {
    color: "#999",
  },
  justifyCenter: {
    justifyContent: "center !important",
    paddingBottom: "0 !important",
  },
  margin5: {
    fontSize: "9px",
    textTransform: "capitalize",
    textAlign: "left",
    marginLeft: "20px",
    textIndent: "-5px",
    minWidth: "75px",
  },
  //Carousel Styles
  centerDiv: {
    margin: "20px auto 0 !important",
    width: "156px",
    border: "0px solid #73AD21",
    padding: "0",
  },
  leftAlign: {
    padding: "15px 10px 15px",
    backgroundColor: "#eaf6fe",
  },
  jobIcons: {
    fill: `${sidebarColor}`,
    verticalAlign: "middle",
    margin: "0 5px 0px 0px",
  },
  favouriteIcon: {
    width: "21px",
    margin: "0 7px !important",
    "@media (max-width: map-get($grid-breakpoints, 'lg'))": {
      width: "16px",
      height: "16px",
    },
  },
  small: {
    padding: "5px 0 0 0",
    lineHeight: "1.5",
    fontFamily: "var(--font-brandon-grotesque)",
    fontSize: "15px",
    fontWeight: 100,
    "& strong": {
      fontFamily: "var(--font-brandon-grotesque)",
      fontWeight: 900,
    },
  },
  section: {
    padding: "30px 0 0px",
  },
  jobCard: {
    marginBottom: 0,
    paddingLeft: "0px",
    paddingRight: "0px",
    marginTop: "0",
    borderTop: "none",
    boxShadow: "none",
    borderRadius: "0",
  },
  cardFooter: {
    padding: "0.9375rem 15px !important",
    alignItems: "flex-start",
    flexWrap: "wrap",

    ".MuiGrid-styledGridItem": {
      padding: "0 !important",
    },
  },
  container: {
    ...container(theme),
  },
  marginAuto: {
    marginLeft: "auto !important",
    marginRight: "auto !important",
  },
  sideIcon: {
    width: "auto",
    paddingRight: "0",
    minWidth: "auto",
    height: "auto",
    paddingLeft: "4px",
    marginTop: "0",
    paddingTop: "0px",
    minHeight: "auto",
    marginBottom: "0",
    paddingBottom: "0",
    lineHeight: 3,
    right: "-9px",
    position: "absolute",
  },
  sideRightIcon: {
    float: "right",
    right: "15px",
  },
});

export default jobOverviewStyle;
